module.exports = __webpack_public_path__ + "media/16.d8d631b3.mp3";